/* eslint-disable */
// COPIA del motor de simulación del backend (backend/utils/calendar.js) para correr la
// simulación en el navegador. Si cambia el del backend, re-copiar. Ver docs/ARQUITECTURA_CARRERA.md
// Generador de calendario de liga (round-robin doble, ida y vuelta) usando el método del círculo.

// Devuelve la cantidad total de jornadas para `n` clubes (par o impar).
function roundsForCount(n) {
    const slots = n % 2 === 0 ? n : n + 1;
    return (slots - 1) * 2;
}

// Mezcla in-place (Fisher-Yates).
function shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
}

// clubTmIds: array de tm_id (string). Devuelve:
// [{ jornada: 1, partidos: [{ home_tm_id, away_tm_id }, ...] }, ...]
// Si `clubTmIds.length` es impar, se agrega un BYE virtual (null) — el club
// emparejado con el BYE en una jornada descansa (no aparece en `partidos`).
// El orden de entrada se mezcla al azar para que cada temporada (y cada partida)
// genere un fixture distinto: con el mismo club ya no enfrentás siempre a los
// rivales en el mismo orden ni con la misma localía.
function generateCalendar(clubTmIds) {
    const ids = shuffle([...clubTmIds]);
    if (ids.length % 2 !== 0) ids.push(null);

    const n = ids.length;
    const roundsIda = n - 1;
    const half = n / 2;

    // Rotación fija: el primer elemento queda fijo, el resto rota en sentido horario.
    let arr = [...ids];
    const idaRounds = [];
    for (let r = 0; r < roundsIda; r++) {
        const partidos = [];
        for (let i = 0; i < half; i++) {
            const home = arr[i];
            const away = arr[n - 1 - i];
            if (home === null || away === null) continue;
            // Alterna localía por jornada para que el fijo no sea siempre local.
            if (r % 2 === 0) {
                partidos.push({ home_tm_id: home, away_tm_id: away });
            } else {
                partidos.push({ home_tm_id: away, away_tm_id: home });
            }
        }
        idaRounds.push(partidos);

        // Rotar todos menos el primero.
        const fixed = arr[0];
        const rest = arr.slice(1);
        rest.unshift(rest.pop());
        arr = [fixed, ...rest];
    }

    // Vuelta: mismas jornadas con localía invertida.
    const vueltaRounds = idaRounds.map((partidos) =>
        partidos.map((p) => ({ home_tm_id: p.away_tm_id, away_tm_id: p.home_tm_id }))
    );

    const allRounds = [...idaRounds, ...vueltaRounds];
    return allRounds.map((partidos, idx) => ({
        jornada: idx + 1,
        partidos: partidos.map((p) => ({
            home_tm_id: p.home_tm_id,
            away_tm_id: p.away_tm_id,
            gh: null,
            ga: null,
            jugado: false,
        })),
    }));
}

// Genera una "fase de liga" de `rounds` jornadas para un pool de equipos: cada jornada
// es un emparejamiento sin repetir rivales (se toman las primeras rondas de ida del
// round-robin completo, válido mientras `rounds <= clubTmIds.length - 1`).
function generateLeaguePhase(clubTmIds, rounds = 8) {
    const full = generateCalendar(clubTmIds);
    return full.slice(0, rounds).map((j, idx) => ({
        jornada: idx + 1,
        partidos: j.partidos,
    }));
}

export { generateCalendar, roundsForCount, generateLeaguePhase };